package one.healthium.ui.compose.components

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.window.DialogProperties

@Composable
actual fun AppAlertDialog(
    modifier: Modifier,
    positiveButton: String?,
    negativeButton: String?,
    onPositiveClick: (() -> Unit)?,
    onNegativeClick: (() -> Unit)?,
    positiveButtonType: AlertButtonType,
    negativeButtonType: AlertButtonType,
    title: String?,
    text: String?,
    onDismissRequest: () -> Unit,
    dismissible: Boolean
) {
    AlertDialog(
        onDismissRequest = onDismissRequest,
        title = title?.let { { Text(title) } },
        text = text?.let { { Text(text) } },
        confirmButton = {
            TextButton(onClick = {
                onPositiveClick?.invoke()
                onDismissRequest()
            }) {
                Text(positiveButton ?: "Ok")
            }
        },
        dismissButton = negativeButton?.let {
            {
                TextButton(onClick = {
                    onNegativeClick?.invoke()
                    onDismissRequest()
                }) {
                    Text(negativeButton)
                }
            }
        },
        properties = DialogProperties(
            dismissOnClickOutside = dismissible,
            dismissOnBackPress = dismissible,
        )
    )
}